import { MerchandisingModalService } from './merchandising-modal.service';

export default angular
  .module('sfMobile.services.merchandising-modal', [
    'pascalprecht.translate',
    'sfMobile.services.modal',
    'sfMobile.services.image-source',
  ])
  .factory('merchandisingModalService', MerchandisingModalService).name;
